import { GET_USER } from 'ggApp/modules/auth/actionTypes';

export const POST_EVENTS = {
    SET_APP_DATA: 'SET_APP_DATA',
    GET_USER,
    WEB_VIEW_LOADED: 'WEB_VIEW_LOADED',
    RATING_CLICKED: 'RATING_CLICKED',
    RATING_SUCCESS: 'RATING_SUCCESS',
    CLIPBOARD_WRITE: 'CLIPBOARD_WRITE',
    REFRESH_CARD_TAB: 'REFRESH_CARD_TAB',
    ORDER_GROVER_CARD: 'ORDER_GROVER_CARD',
};
